__turbopack_context__.v({
  "description": "theme-form-module__9VHICq__description",
  "input": "theme-form-module__9VHICq__input",
  "label": "theme-form-module__9VHICq__label",
  "wrapper": "theme-form-module__9VHICq__wrapper",
});
